export default __webpack_public_path__ + "static/media/shortcut_technical_support.65401ebb.svg";